const isDarkQuery = window.matchMedia('(prefers-color-scheme: dark)');
const isNoPreferenceQuery = window.matchMedia('(prefers-color-scheme: no-preference)');
const isLightQuery = window.matchMedia('(prefers-color-scheme: light)');
//should match one of the three
const isSupported = isDarkQuery.matches || isNoPreferenceQuery.matches || isLightQuery.matches;
export const initialMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
export const supportsDarkMode = isSupported; //TODO: add check?
//# sourceMappingURL=initial-mode.web.js.map